module.exports = __webpack_public_path__ + "static/GetStarted-8-7707c1726c0490f628a2dc2559597d6a.jpg";